/**
 * Smoothly scrolls to an in-page section and corrects the landing position if
 * sections above it (lazy-loaded) change height while the scroll is running.
 * The page's scroll-padding-top keeps the section heading clear of the sticky header.
 */
export function scrollToAnchor(hash: string) {
  const id = hash.replace(/^#/, '')
  const target = () => document.getElementById(id)
  const el = target()
  if (!el) return false

  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches
  const behavior: ScrollBehavior = reduceMotion ? 'auto' : 'smooth'

  el.scrollIntoView({ behavior, block: 'start' })
  if (window.location.hash !== `#${id}`) {
    window.history.pushState(null, '', `#${id}`)
  }

  // Re-check a few times: if content above loaded and pushed the section, land on it again.
  const padding = parseFloat(getComputedStyle(document.documentElement).scrollPaddingTop) || 0
  let checks = 0
  const verify = () => {
    checks += 1
    const current = target()
    if (!current) return
    const drift = current.getBoundingClientRect().top - padding
    if (Math.abs(drift) > 12) current.scrollIntoView({ behavior, block: 'start' })
    if (checks < 3) window.setTimeout(verify, 700)
  }
  window.setTimeout(verify, reduceMotion ? 150 : 900)
  return true
}
